import { useState, useRef, useEffect, useCallback } from 'react';

export const useTimeout = (callback: (params?: any) => any, delay: number = 2000, params?: any) => {
  const [value, setValue] = useState<string>();
  const callbackRef = useRef(callback);
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();
  const firstRenderRef = useRef(true);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  const set = useCallback(() => {
    timeoutRef.current = setTimeout(() => callbackRef.current(params), delay);
  }, [delay, params]);

  const clear = useCallback(() => {
    timeoutRef.current && clearTimeout(timeoutRef.current);
  }, []);

  useEffect(() => {
    if (firstRenderRef.current) {
      firstRenderRef.current = false;
    } else {
      set();

      return clear;
    }
  }, [value, set, clear]);

  return { value, setValue };
};
